import "./Home.css";
import { useEffect } from "react";
// import axios from "axios";
import SliderFilter from "../../components/sliderFilter/SliderFilter";
import AboutUsSection from "../../components/aboutUsSection/AboutUsSection";
import ServicesTabs from "../../components/servicesTabs/ServicesTabs";
import OurProjectSection from "../../components/ourProjectSection/OurProjectSection";
import LastSection from "../../components/lastSection/LastSection";
import Counter from "../../components/counter/Counter";
// import CardProjects2 from "../../components/cardProjects2/CardProjects2";
// import ProjectsComponent from "../../components/projectsComponent/ProjectsComponent";
// import Slider from "../../components/slider/Slider";
// import { useEffect } from "react";
export default function Home() {
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling animation
    });
  }

  useEffect(() => {
    scrollToTop();
  }, []);
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling animation
    });
  }

  useEffect(() => {
    scrollToTop();
  }, []);
  return (
    <>
      <SliderFilter />
      <AboutUsSection
        head={"معلومات عنا"}
        heading={"هل تبحث عن منزل احلامك"}
        heading2={"وصلت لوجهتك مع أبعاد العقارية"}
        slog={
          "نحن هنا نساعدك في رحلة تملُك منزل احلامك بطريقة سهلة ويسيرة , بخدمات كاملة تثق بها"
        }
      />
      <Counter />
      <ServicesTabs
        stylecolor={true}
        heading={"أبعـــاد العقارية"}
        heading2={"رفيقك في رحلة شراء منزل أحلامك"}
        desc={
          "تعرّف على ما نقدمه، واكتشف كيفية جعل ملكيتك صفقة ناجحة، لا تكتفي ببيع عقارك فقط، بل ابحث عن شريكك الموثوق الذي يضمن لك ثقة عالية وتجربة استثنائية"
        }
      />
      {/* <ProjectsComponent/> */}
      {/* <Slider/> */}
      <OurProjectSection />
      <LastSection />
    </>
  );
}
